<template>
    <div class="engineering">
        <el-container>
            <el-main ref="main">
                <el-table
                        ref="dataTable"
                        :data="engineerList"
                        highlight-current-row
                        size="mini"
                        height="100%"
                        border
                >
                    <el-table-column prop="projectDeptName" label="项目部" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="projectName" label="项目" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="subCategoryName" label="细目名称-总包" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="subCategoryNo" label="细目编码" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="createTime" label="备份时间" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="projectName" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="uploadTxt(scope.row)" size="small">下载</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
            <el-footer>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
    import {
        getFrontHistroyService,
        frontHistoryExportService,
    } from '../../../services/engineering'
    import {exportExcelService2} from "../../../services/allContractServices";
    export default {
        name: "historyEdition",
        data(){
            return {
                dataForm:{
                    pageIndex: 1,
                    pageSize: 10,
                },
                generalContractProjectDetailsId: '',
                engineerList: [],
            }
        },
        methods: {
            onActive(menuCode) {
                this.generalContractProjectDetailsId = this.tabRouteParam.id
                this.getFrontHistroy()
            },
            //查询历史版本
            getFrontHistroy(){
                let params = {
                    generalContractProjectDetailsId: this.generalContractProjectDetailsId
                }
                getFrontHistroyService(params).then( res => {
                    if(res.code == 10000000){
                        this.engineerList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //下载
            uploadTxt(row){
                let params = {
                    id: row.id
                }
                frontHistoryExportService(params).then( res => {
                    if(res.code == 10000000){
                        exportExcelService2(res.data).then(res1 => {
                            this.$message.success('导出成功');
                        });
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .engineering {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
    }
</style>
